import React, { Component } from 'react';
import Forecast from './forecast';
import History from './history';

export default class index extends Component {
  render() {
    return (
      <div>
        <Forecast></Forecast>
        <History></History>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/table/4new/4.3/4.3.1/index.js